import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

import { HttpClient } from "@angular/common/http";
const LNG_KEY = "SELECTED_LANGUAGE";
@Injectable()
export class TranslateConfigService {
  constructor(private translate: TranslateService, private http: HttpClient) {}

  setLanguage(setLang) {
    this.translate.use(setLang);
    localStorage.setItem(LNG_KEY, setLang);
  }

  // getDefaultLanguage() {
  //   let language = this.translate.getBrowserLang();
  //   console.log(language, "default");

  //   let value = localStorage.getItem(LNG_KEY);
  //   if (value === "" || value === null || value === undefined) {
  //     this.translate.setDefaultLang(language);
  //   } else {
  //     this.setLanguage(value);
  //   }

  //   return language;
  // }
}
